import { useCallback } from "react";
import { CopyOutlined } from "@ant-design/icons";
import { message } from "antd";

export function SpaInlineCopyRow(props: {
  text: string;
  successMessage?: string;
  errorMessage?: string;
  ariaLabel: string;
  title?: string;
  className?: string;
  textClassName?: string;
  buttonClassName?: string;
}): JSX.Element {
  const {
    text,
    successMessage = "已复制",
    errorMessage = "复制失败，请重试",
    ariaLabel,
    title = "复制",
    className,
    textClassName,
    buttonClassName,
  } = props;
  const onCopy = useCallback(() => {
    void navigator.clipboard.writeText(text).then(
      () => {
        message.success(successMessage);
      },
      () => {
        message.error(errorMessage);
      }
    );
  }, [text, successMessage, errorMessage]);

  return (
    <div className={className}>
      <span className={textClassName} translate="no">
        {text}
      </span>
      <button
        type="button"
        className={buttonClassName}
        onClick={onCopy}
        aria-label={ariaLabel}
        title={title}
      >
        <CopyOutlined />
      </button>
    </div>
  );
}
